// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"283":"a3957248","996":"c8be8685"}[chunkId] + ".chunk.js";
};